import { Img } from './Img';
import { SectionHead, Reveal } from './Bits';

const SHOTS = [
  { src: 'https://dtwaeonhht2im.cloudfront.net/c1586e6d1af4f2e9910af054b0ef248e-1.jpeg', label: 'Crispy dosa, banana leaf', span: 'md:col-span-2 md:row-span-2' },
  { src: 'https://storage.googleapis.com/happyspace-generated-images/generated/2026-07-09/78f71bdf9e1c.png', label: 'Filter coffee & Irani chai', span: 'md:row-span-2' },
  { src: 'https://dtwaeonhht2im.cloudfront.net/d678fb6d5baad869879cc752e58e8237-1.jpeg', label: 'Chettinad curries', span: '' },
  { src: 'https://storage.googleapis.com/happyspace-generated-images/generated/2026-07-09/9d26804d3029.png', label: 'Dum biryani', span: '' },
  { src: 'https://dtwaeonhht2im.cloudfront.net/52c0b11fd3b1d1cfe7b099cad173a35b.jpg', label: 'The full spread', span: 'md:col-span-2' },
  { src: 'https://dtwaeonhht2im.cloudfront.net/7ff805516c34b94f10e9dd8aa9eb9535.png', label: 'Ghee parotta & curry', span: '' },
];

export function Gallery() {
  return (
    <section className="wrap py-20 md:py-28">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
        <SectionHead kicker="A Feast for the Senses" title="Straight from our kitchen" intro="Griddled, simmered and plated to order — this is what lands on your table." />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[160px] md:auto-rows-[200px]">
        {SHOTS.map((s, i) => (
          <Reveal as="div" key={s.src} delay={i * 70} className={`group relative overflow-hidden rounded-[var(--pe-radius)] ${s.span}`}>
            <Img src={s.src} alt={s.label} className="h-full w-full" imgClassName="group-hover:scale-105" />
            <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(20,14,10,0.7) 0%, transparent 55%)' }} />
            <span className="absolute left-4 bottom-3.5 font-display text-white text-[0.95rem] md:text-base drop-shadow">
              {s.label}
            </span>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
